import { cuboidMotionCompensated } from '../ego-motion-compensation-cuboid-material-utils';
import { pointMotionCompensated } from '../ego-motion-compensation-material-utils';
import { brownConradyProjection } from './brown-conrady-projection';
import {
  commonCylindrical,
  cylindricalProjection,
} from './cylindrical-projection';
import { deformedCylindricalProjection } from './deformed-cylinder-projection';
import { fisheyeProjection } from './fisheye-projection';
import { lutProjection } from './lut-projection';
import { projectionUniforms } from './projection-uniforms';

const h3getProjection = `
vec4 getProjection(mat4 h3ProjectionMatrix, mat4 h3ViewMatrix) {
  vec3 h3Position = vec3( position );

  #if defined ( USE_MOTION_COMPENSATION )
    #if defined ( IS_CUBOID )
      h3Position = getCuboidMotionCompensatedPosition(h3Position);
    #elif defined ( IS_POINT )
        h3Position = getPointMotionCompensatedPosition(h3Position);
    #endif
  #endif

  #if defined ( USE_LUT_PROJECTION )

    return getLutPosition(h3Position);

  #elif defined ( USE_CYLINDRICAL_PROJECTION )

    return getCylindricalPosition(h3Position, h3ViewMatrix);

  #elif defined ( USE_DEFORMED_CYLINDRICAL_PROJECTION )

    return getDeformedCylindricalPosition(h3Position, h3ViewMatrix);

  #elif defined ( USE_FISHEYE_PROJECTION )

    return getFisheyePosition(h3Position, h3ProjectionMatrix, h3ViewMatrix);

  #elif defined ( USE_BROWN_CONRADY_PROJECTION )

    return getBrownConradyPosition(h3Position, h3ProjectionMatrix, h3ViewMatrix);

  #else

    return h3ProjectionMatrix * h3ViewMatrix * modelMatrix * vec4(h3Position, 1.0);

  #endif
}
`;

export const h3ProjectionFunctions = `
${projectionUniforms}

#if defined ( USE_MOTION_COMPENSATION )
  #if defined ( IS_CUBOID )
    ${cuboidMotionCompensated}
  #elif defined ( IS_POINT )
    ${pointMotionCompensated}
  #endif
#endif

${lutProjection}
${commonCylindrical}
${cylindricalProjection}
${deformedCylindricalProjection}
${fisheyeProjection}
${brownConradyProjection}
// needs to be after all other projection vertex shaders
${h3getProjection}
`;
